import React, {useEffect, useState} from 'react';
import {OTPApprovalModalProps} from "../../models";
import {Button, Flex, Form, Input, message, Modal} from "antd";
import {StyledCountDown} from "../../../userManagement/components/loginCard/LoginCard.styled";
import {OTPProps} from "antd/es/input/OTP";
import {connect} from "react-redux";
import {
    registerBorrowRequestApprovalByBorrower,
} from "../../actions/Cartable.action";
import {withRouter} from "../../../../utils/services/with-router";

const OTPApprovalModal = ({open, onCanselHandel, secondsLeft,registerBorrowRequestApprovalByBorrower,id,onHandleOk}: OTPApprovalModalProps) => {
    const [timer, setTimer] = useState(120); // 120 seconds (2 minutes) for OTP countdown
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false); // 120 seconds (2 minutes) for OTP countdown
    const onChange: OTPProps['onChange'] = (text) => {
        console.log(text)
        onFinish({code:text})
        form.setFieldValue('onChange:', text);
    };

    const onInput: OTPProps['onInput'] = (value) => {
    };
    const sharedProps: OTPProps = {
        onChange,
        onInput,
    };
    const startTimer = (count: number) => {

        setTimer(count);
        const interval = setInterval(() => {
            count -= 1;
            setTimer(count);
            if (count <= 0) {
                clearInterval(interval); // Stop timer when it reaches 0
                onCanselHandel()
            }
        }, 1000);
    };
    const onFinish = (code:any) => {
        setLoading(true)
        let model = {
            id :id,
            isApproved:true,
            code:code.code,
        }

        registerBorrowRequestApprovalByBorrower(model)
            .then((data: any) => {
                setLoading(false)
                if (data.payload != undefined) {
                    message.success("درخواست با موفقیت ثبت شد")
                    onHandleOk()
                }
            })
            .catch((e: any) => {
            });
    }
    useEffect(() => {
        startTimer(secondsLeft)
    }, [secondsLeft]);
    return (
        <Modal

            width={"100%"}
            open={open}
            onCancel={onCanselHandel}
            maskStyle={{
                backdropFilter: "blur(6px)",
                backgroundColor: "rgba(0,0,0,0.3)" // optional (better contrast)
            }}
            footer={null}>
            <Form form={form} layout={"vertical"} onFieldsChange={(i:any) => console.log(i)} onFinish={onFinish}>
                <Flex vertical justify={"center"} gap={"large"}>
                    <Form.Item
                        name="code"
                        label={` کد 4 رقمی که ارسال شده است را وارد کنید`}
                        rules={[
                            { required: true, message: "کد ارسال شده را وارد کنید." },
                        ]}
                    >
                        <Input.OTP length={4} style={{direction:"ltr",width:"100%",display:"flex",justifyContent:"center"}}
                                   formatter={(str) => str.toUpperCase()} {...sharedProps} type={"number"}/>
                    </Form.Item>
                    <Flex justify={"center"} vertical gap={"middle"}>
                        <Flex gap={"small"} justify={"center"} align={"baseline"}>
                            <small>زمان باقی مانده : </small>
                            <StyledCountDown
                                format={"mm:ss"}
                                value={Date.now() + timer * 1000} // Pass the deadline in milliseconds
                                onFinish={() => onCanselHandel()}
                            />
                        </Flex>
                      <Flex gap={"large"}>
                          <Button block type={"primary"} loading={loading} htmlType={"submit"}>تایید</Button>
                          <Button block loading={loading} onClick={() => onCanselHandel()}>لغو</Button>
                      </Flex>
                    </Flex>
                </Flex>
            </Form>

        </Modal>
    );
};

export default connect(null, {registerBorrowRequestApprovalByBorrower})(
    withRouter(OTPApprovalModal)
);